import React from 'react';
import { motion } from 'framer-motion';

// Page-specific CSS for background and mature styling
const admissionsBgStyle = `
.admissions-page {
  background: linear-gradient(135deg, #233c2e 0%, #2e2540 100%);
  min-height: 100vh;
}
.admissions-card {
  background: rgba(255,255,255,0.95);
  border-radius: 1.2rem;
  box-shadow: 0 4px 24px rgba(38,99,235,0.10);
  border: 1px solid #e0e7ef;
  padding: 2rem 1.5rem;
  margin-bottom: 2rem;
}
.admissions-class-title {
  color: #2563eb;
  font-weight: 600;
  font-size: 1.25rem;
}
`;

const classes = [
  "JSS1", "JSS2", "JSS3",
  "SS1", "SS2", "SS3"
];

const AdmissionsPrograms = () => {
  return (
    <>
      <style>{admissionsBgStyle}</style>
      <div className="admissions-page min-h-screen">
        <div className="container mx-auto px-2 sm:px-4 py-8 sm:py-12">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2 }}
            className="max-w-3xl mx-auto text-center mb-10"
          >
            <h1 className="text-3xl sm:text-4xl font-heading font-bold text-primary mb-3">
              Admissions & Programs
            </h1>
            <p className="text-base sm:text-lg text-muted-foreground mb-2">
              Explore our academic programs and admission opportunities for all classes from JSS1 to SS2.
            </p>
            <p className="text-lg font-semibold text-primary">
              Admissions are open for all classes listed below!
            </p>
          </motion.div>

          <div className="max-w-3xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
            {classes.map((className) => (
              <div key={className} className="admissions-card flex flex-col items-center">
                <span className="admissions-class-title mb-2">{className}</span>
                <p className="text-muted-foreground text-center mb-3">
                  Admission is available for {className}. Join Anglican College Owerrinta for a transformative academic experience, holistic development, and a nurturing environment.
                </p>
                <a
                  href="/contact"
                  className="bg-primary text-white px-5 py-2 rounded-lg font-semibold shadow hover:bg-primary/90 transition"
                >
                  Apply Now
                </a>
              </div>
            ))}
          </div>

          <div className="max-w-3xl mx-auto text-center mt-12">
            <p className="text-base sm:text-lg text-muted-foreground">
              For more information about our programs, curriculum, and admission process, please contact the school administration or visit our campus.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdmissionsPrograms;